<template>
  <section class="task-header">
    <div class="inner">
      <div class="utill">
        <div
          class="dropdown right ty1 small okr"
          v-if="isInternalUser && okrUse && tenantId == 201"
        >
          <v-menu bottom left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="link-okr"
                >OKR {{ projectOkrLinkCount }}</v-btn
              >
            </template>
            <div>
              <div class="top clear">
                <div class="dropdown ty2 relative fl" v-if="qrtList.length > 0">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">{{
                        $i18nUtil.getLanguage() !== 'ko' && currentQrt.qrtTopMsgEn != null ? currentQrt.qrtTopMsgEn : currentQrt.qrtTopMsg
                      }}</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div
                        class="dropdown-list-item"
                        v-for="(item, index) in qrtList"
                        :key="'qrt' + index"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{ active: item.QRT_CD == currentQrt.qrtCd }"
                            @click="qrtChange(item.QRT_CD, $event)"
                          >
                            {{ $i18nUtil.getLanguage() !== 'ko' && item.QRT_TOP_MSG_EN != null ? item.QRT_TOP_MSG_EN : item.QRT_TOP_MSG }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </div>
                <button
                  type="button"
                  class="btn_link_add fr"
                  v-if="isProjectMember"
                  @click="LinkedOkrPopup"
                >
                  OKR 연결 추가
                </button>
              </div>
              <div class="nodata" v-if="projectOkrLinkList.length == 0">
                연결된 OKR이 없습니다.
              </div>
              <div class="scroll" v-else>
                <ul>
                  <li
                    :class="{ disabled: item.holdYn == 1 }"
                    v-for="(item, index) in projectOkrLinkList"
                    :key="'Okr' + index"
                  >
                    <div class="clear">
                      <div class="fl kr">{{ ChangeOkrType(item.okrType) }}</div>
                      <div class="droplayer tooltipmember relative fl">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on"
                              ><b>{{ $i18nUtil.getLanguage() !== 'ko' && item.regUserNameEn != null ? item.regUserNameEn : item.regUserName }}</b></v-btn
                            >
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip :userId="item.regUserId" />
                          </div>
                        </v-menu>
                      </div>
                      <div
                        class="dividing_line_ty3"
                        v-if="item.holdYn == 1"
                      ></div>
                      <div class="icon-txt-pause" v-if="item.holdYn == 1">
                        일시정지
                      </div>
                      <button
                        type="button"
                        class="fr unlink"
                        v-if="item.regUserId == userId"
                        @click="OkrDisconnection(item.projectOkrLinkId)"
                      >
                        연결 해제
                      </button>
                    </div>
                    <div class="tit">{{ item.okrTitle }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </v-menu>
        </div>

        <div class="dividing_line_ty4" v-if="isInternalUser && okrUse && tenantId == 201"></div>
        <!-- <div class="dropdown ty1 small relative right member project_comment"> -->
        <div class="dropdown ty1 small relative right member project_comment">
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" ref="viewCommentBtn">
                {{$i18nUtil.trans("title.ProjectCommentModal.001", "과제 의견")}} <b>{{ projectCommentCount }}</b>
              </v-btn>
            </template>
            <div class="dropdown-list">
              <ProjectComment
                :callFrom="'dashboardHeader'"
                :projectId="projectId"
                :groupId="groupId"
                :userId="userId"
                :memberList="projectMemberList"
                :toggleBtn="$refs.viewCommentBtn"
                @setProjectMemberCount="setProjectMemberCount"
              />
            </div>
          </v-menu>
        </div>
        <div class="dividing_line_ty4"></div>
        <div class="dropdown ty1 small relative right member">
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" @click="searchReset"
                ><b>{{$i18nUtil.trans("entity.cogroupUser.groupKbn.pro","과제 멤버")}} {{ projectMemberCount }}</b></v-btn
              >
            </template> 
            <div class="dropdown-list member-search_box" :class="isProjectMember ? 
                                                                    isInternalUser ? 
                                                                      projectInfo.isInviteUse ? 'two' : 'one' 
                                                                    : projectInfo.isInviteUse ? 'one other' : '' 
                                                                 :''">
              <form
                action=""
                v-if="isInternalUser && isProjectMember"
                onsubmit="return false;"
              >
                <div class="search_ty1">
                  <input
                    type="text"
                    id="searchInput"
                    :class="{ ico_search: searchKeyword.length == 0 }"
                    @focus="$event.target.placeholder = ''"
                    @focusout="
                      $event.target.placeholder = $i18nUtil.trans('message.DashboardHeader.001','담당자 이름으로 검색')
                    "
                    :placeholder="$i18nUtil.trans('message.DashboardHeader.001','담당자 이름으로 검색')"
                    autocomplete="off"
                    @keyup.enter="searchByKeyword"
                    @input="searchByKeyword"
                    :value="searchKeyword"
                  />
                  <button
                    type="reset"
                    class="btn_search"
                    @click="clickMemberSearchBtn"
                  >
                    검색
                  </button>
                  <div class="member-call-box" v-if="isSearch">
                    <div class="scroll">
                      <div class="nodata" v-if="userList.length == 0">
                        <div class="txt" v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')">
                        </div>
                      </div>
                      <dl v-if="userList.length > 0">
                        <dt>{{ $i18nUtil.trans("message.DashBoardHeader.026","멤버 검색 결과") }}</dt>
                        <dd>
                          <div
                            class="nodata"
                            v-if="searchMemberList.length == 0"
                            v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')"
                          >
                          </div>
                          <ul
                            class="member-list"
                            v-else
                            v-for="(item, index) in searchMemberList"
                            :key="'member' + index"
                          >
                            <li>
                              <div
                                class="img user-photo"
                                :data-user-id="item.userId"
                              >
                                <img src="@/assets/img/no-avatar.png" alt="" />
                              </div>
                              <b class="name ell-singleline"
                                >{{ item.userName }}
                                <span>{{ item.positionName }}</span></b
                              >
                              <span class="team ell-singleline"
                                >{{ item.companyName }} /
                                {{
                                  item.isExternalUser
                                    ? item.partnerName
                                    : item.deptName
                                }}</span
                              >
                            </li>
                          </ul>
                        </dd>
                      </dl>
                      <dl v-if="userList.length > 0">
                        <dt v-html="$i18nUtil.trans('message.DashBoardHeader.003','멤버 외 검색 결과 <br />(선택 시 멤버로 자동 추가됩니다.)')">
                        </dt>
                        <dd>
                          <div
                            class="nodata"
                            v-if="searchNoMemberList.length == 0"
                            v-html="$i18nUtil.trans('message.DashBoardHeader.004','해당 검색어와 일치하는<br />사용자가 없습니다.')"
                          >
                          </div>
                          <ul class="member-list" v-else>
                            <li
                              v-for="(item, index) in searchNoMemberList"
                              :key="'noMember' + index"
                              @click="selectProjectUser(item, index)"
                            >
                              <div
                                class="img user-photo"
                                :data-user-id="item.userId"
                              >
                                <img src="@/assets/img/no-avatar.png" alt="" />
                              </div>
                              <b class="name ell-singleline"
                                >{{ item.userName }}
                                <span>{{ item.positionName }}</span></b
                              >
                              <span class="team ell-singleline"
                                >{{ item.companyName }} /
                                {{
                                  item.isExternalUser
                                    ? item.partnerName
                                    : item.deptName
                                }}</span
                              >
                            </li>
                          </ul>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </form>
              <div class="link_box" v-if="isInternalUser && isProjectMember">
                <button type="button" class="link" @click="addMember">
                  {{ $i18nUtil.trans("button.member.add.orgChart", "조직도에서 멤버 추가") }}
                </button>
                <button
                  type="button"
                  class="link"
                  @click="invitationMember"
                  v-if="isProjectMember && projectInfo.isInviteUse"
                >
                  {{ $i18nUtil.trans("button.member.add.external", "외부협력사 멤버 초대") }}
                </button>
              </div>

              <div class="scroll_box">
                <dl
                  class="my"
                  v-for="(item, index) in projectMemberList"
                  :value="item.userId"
                  :key="'A' + index"
                  v-show="item.userId == userId"
                >
                  <dt>{{ $i18nUtil.trans("message.DashBoardHeader.027","본인") }}</dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="name">
                          {{ item.userName }} {{ item.jobPositionName }}
                          <span
                            :class="{
                              'ico-master' : item.userGrade == 'MANAGER',
                              'ico-master-en' : item.userGrade == 'MANAGER' && $i18nUtil.getLanguage() === 'en'
                            }"
                            >{{
                              item.userGrade == "MEMBER"
                                ? ""
                                : $i18nUtil.trans("message.DashBoardHeader.028","운영자")
                            }}</span
                          >
                              <!-- 'ico-master':
                                item.userGrade == 'MANAGER'
                                  ? item.userId != projectInfo.project.regUserId
                                    ? true
                                    : false
                                  : false,
                              'ico-creat':
                                item.userId == projectInfo.project.regUserId
                                  ? true
                                  : false, -->
                              <!-- item.userId == projectInfo.project.regUserId
                                ? "생성자"
                                : item.userGrade == "MEMBER"
                                ? ""
                                : "운영자" -->
                        </div>
                        <div class="mail">
                          {{ item.companyName }} /
                          {{
                            item.isExternalUser
                              ? item.partnerName
                              : item.deptName
                          }}
                        </div>
                        <button
                          type="button"
                          class="logout"
                          @click="
                            showDialog(
                              item.userGrade,
                              item.userId,
                              item.userName,
                              item.userKbn,
                              'SELF_REJECT'
                            )
                          "
                        >
                          나가기
                        </button>
                      </li>
                    </ul>
                  </dd>
                </dl>

                <dl class="colleague" v-if="projectInfo.isInviteUse">
                  <dt class="accodian active">
                    <button
                      type="button"
                      @click=" $event.target.parentElement.classList.toggle('active')"
                    >
                      {{$i18nUtil.trans("message.DashBoardHeader.029","과제 멤버 가입 대기")}} ({{ projectInvitationMemberCount }})
                    </button>

                    <button
                      v-if="grade == 'MANAGER'"
                      @click="projectSetting('INVITE')"
                      class="ico-setting"
                    >
                      설정
                    </button>
                  </dt>
                  <dd>
                    <div
                      class="nodata"
                      v-if="projectInvitationMemberList.length == 0"
                      v-html="$i18nUtil.trans('message.DashBoardHeader.005','가입 대기 중인 외부협력사 <br />멤버가 없습니다.')"
                    >
                    </div>
                    <ul v-else>
                      <li
                        :class="{
                          disabled:
                            (item.status == 'JOIN') ||(item.status == 'BEFORE REQUEST')
                        }"
                        v-for="(item, index) in projectInvitationMemberList"
                        :key="'C' + index"
                      >
                        <div class="droplayer relative">
                          <v-menu bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" class="name">{{
                                item.userName
                              }}</v-btn>
                            </template>
                            <div
                              class="dropdown-list"
                              v-if="item.status == 'JOIN' && isInternalUser"
                            >
                              <UserTooltip :userId="item.userId" />
                            </div>
                          </v-menu>
                        </div>
                        <button
                          type="button"
                          class="btn-txt-link"
                          v-if="item.status == 'JOIN' && grade == 'MANAGER'"
                          @click="invitationApprove(item.userMngMid, item.email)"
                        >
                          {{ $i18nUtil.trans("button.approve.externalUser", "가입 승인") }}
                        </button>
                        <button
                          type="button"
                          class="btn-txt-link disabled"
                          v-else-if="item.status == 'JOIN' && grade != 'MANAGER'"
                        >
                          {{ $i18nUtil.trans("button.wait.approval.externalUser", "승인 대기") }}
                        </button>
                        <button
                          type="button"
                          class="btn-txt-link"
                          v-else-if="(item.status == '' || item.status =='BEFORE REQUEST')&&grade == 'MANAGER'"
                          @click="reInvitationMember(item)"
                        >
                          {{ $i18nUtil.trans("button.reinvite.externalUser", "다시 초대") }}
                        </button>
                        <button
                          type="button"
                          class="btn-txt-link disabled"
                          v-else-if="item.status == '' && grade != 'MANAGER'"
                         >
                          {{ $i18nUtil.trans("button.wait.complete.externalUser", "승인 완료") }}
                        </button>
                        <button
                          type="button"
                          class="btn-txt-link"
                          v-else-if="item.status =='BEFORE REQUEST' && userId == item.reqUserId"
                          @click="reInvitationMember(item)"
                        >
                          {{ $i18nUtil.trans("button.reinvite.externalUser", "다시 초대") }}
                        </button>
                        <button
                          type="button"
                          class="btn-txt-link disabled"
                          v-else
                        ><!-- status : BEFORE REQUEST -->
                          {{ $i18nUtil.trans("button.wait.join.externalUser", "가입 대기") }}
                        </button>
                      </li>
                    </ul>
                  </dd>
                </dl>
                <dl class="colleague">
                  <dt class="accodian active">
                    <button
                      type="button"
                      @click="
                        $event.target.parentElement.classList.toggle('active')
                      "
                    >
                      {{ $i18nUtil.trans("entity.cogroupUser.groupKbn.pro","과제 멤버") }} ({{ projectMemberCount - 1 }})
                    </button>
                    <button
                      v-if="grade == 'MANAGER'"
                      @click="projectSetting('MEMBER')"
                      class="ico-setting"
                    >
                      설정
                    </button>
                  </dt>
                  <dd>
                    <div
                      class="nodata"
                      v-if="
                        (projectMemberList.length == 1 &&
                          projectMemberList[0].userId == userId) ||
                        projectMemberList.length == 0
                      "
                      v-html="$i18nUtil.trans('message.DashBoardHeader.006','멤버를 구성하여<br />협업해보세요.')"
                    >
                    </div>
                    <ul v-else>
                      <li
                        v-for="(item, index) in projectMemberList"
                        :key="'B' + index"
                      >
                        <div
                          class="droplayer relative"
                          v-if="item.userId != userId"
                        >
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" class="name">
                                {{ item.userName }} {{ item.jobPositionName }}
                                <span
                                :class="{
                                  'ico-master' : item.userGrade == 'MANAGER',
                                  'ico-master-en' : item.userGrade == 'MANAGER' && $i18nUtil.getLanguage() === 'en'
                                }"
                                >{{
                                  item.userGrade == "MEMBER"
                                    ? ""
                                    : $i18nUtil.trans("message.DashBoardHeader.028","운영자")
                                }}</span>
                              </v-btn>
                            </template>
                            <div class="dropdown-list" v-if="isInternalUser">
                              <UserTooltip :userId="item.userId" />
                            </div>
                          </v-menu>
                        </div>
                        <div class="mail" v-if="item.userId != userId">
                          {{ item.companyName }} /
                          {{
                            item.isExternalUser
                              ? item.partnerName
                              : item.deptName
                          }}
                        </div>
                        <!-- <button
                          type="button"
                          class="logout"
                          v-if="item.userId != userId && grade == 'MANAGER'"
                          @click="
                            showDialog(
                              item.userGrade,
                              item.userId,
                              item.userName,
                              item.userKbn,
                              'REJECT'
                            )
                          "
                        >
                          나가기
                        </button> -->
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
          </v-menu>
        </div>
        <div v-if="isProjectMember" class="dividing_line_ty4 last"></div>
        <button
          type="button"
          class="ico-switch_favorites"
          v-if="isProjectMember"
          :class="{
            active: favoriteYn == 1 ? true : false,
          }"
          @click="registProjectFavorites"
        >
          즐겨찾기
        </button>
        <div
          class="droplayer relative icon more large right nosel"
          v-if="isProjectMember"
        >
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
            </template>
            <div class="dropdown-list">
              <div class="dropdown-list-item">
                <div class="tit">
                  <button type="button" @click="otherProjectBoardLink">
                    {{ $i18nUtil.trans("title.OtherProjectBoardLink.001", "타 과제 보드 링크") }}
                  </button>
                </div>
              </div>
              <div class="dropdown-list-item">
                <div class="tit">
                  <button type="button" @click="projectSetting">
                    {{ $i18nUtil.trans("title.ProjectSetting.002", "과제 정보관리") }}
                  </button>
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <!-- <dl class="more_box">
          <dt>
            <button
              type="button"
              class="more"
              v-if="isProjectMember"
              @click="$event.target.parentElement.classList.toggle('active')"
              @mousedown="projectAllComment()"
            >
              더보기
            </button>
          </dt>
          <dd>
            <ul style="width: 128px">
              <li>
                <button type="button" @click="otherProjectBoardLink">
                  타 보드 링크
                </button>
              </li>
              <li>
                <button type="button" @click="projectSetting">
                  정보관리
                </button>
              </li>
            </ul>
          </dd>
        </dl> -->
      </div>
      <!-- //utill -->

      <div class="open_task">
        <div class="label-fin">
          {{
            projectInfo.cogroup.publicYn == 1
              ? $i18nUtil.trans("entity.project.publicYn.Y","전체공개 과제")
              : $i18nUtil.trans("entity.project.publicYn.N","멤버만 공개 과제")
          }}
        </div>
        <div class="dropdown ty1 relative" v-show="tenantId !='418502'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on"
                ><span
                  :class="{
                    'ico-evaluate-good': status == 'GOOD',
                    'ico-evaluate-so': status == 'SO',
                    'ico-evaluate-delay': status == 'DELAY',
                    'ico-evaluate-exceeded': status == 'EXCEEDED',
                  }"
                ></span>
                {{
                  status == "GOOD"
                    ? $i18nUtil.trans("entity.project.projectStatus.GOOD","정상")
                    : status == "SO"
                    ? $i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생")
                    : status == "DELAY"
                    ? $i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요")
                    : status == "EXCEEDED"
                    ? $i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료")
                    : ""
                }}</v-btn
              >
            </template>
            <div class="dropdown-list">
              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    :class="{ active: status == 'GOOD' }"
                    @click="updateProjectStatus('GOOD')"
                  >
                    <span class="ico-evaluate-good"></span> {{ $i18nUtil.trans("entity.project.projectStatus.GOOD","정상") }}
                  </button>
                </div>
              </div>
              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    :class="{ active: status == 'SO' }"
                    @click="updateProjectStatus('SO')"
                  >
                    <span class="ico-evaluate-so"></span> {{ $i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생") }}
                  </button>
                </div>
              </div>
              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    :class="{ active: status == 'DELAY' }"
                    @click="updateProjectStatus('DELAY')"
                  >
                    <span class="ico-evaluate-delay"></span> {{ $i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요") }}
                  </button>
                </div>
              </div>
              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    :class="{ active: status == 'EXCEEDED' }"
                    @click="updateProjectStatus('EXCEEDED')"
                  >
                    <span class="ico-evaluate-exceeded"></span> {{ $i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료") }}
                  </button>
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <div class="droplayer icon info tip relative" v-show="tenantId !='418502'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">설명</v-btn>
            </template>
            <div class="dropdown-list">
              <div class="tooltip-b tl" style="width: 413px">
                <div v-if="tenantId !== '203'">{{ $i18nUtil.trans("message.ProjectFilter.001","평가정보는 과제/보드 멤버가 수동으로 변경 가능합니다.") }}</div>
                <div v-if="tenantId === '203'">{{ $i18nUtil.trans("message.ProjectFilter.001_1","진행단계는 과제/보드 멤버가 수동으로 변경 가능합니다.") }}</div>
                <div v-if="tenantId !== '203'" v-html="$i18nUtil.trans('message.ProjectFilter.010','평가 기준')"></div>
                <div v-if="tenantId === '203'" v-html="'&lt; '+$i18nUtil.trans('entity.projectList.status','진행단계')+' &gt'"></div>
                <div class="tit">
                  <span class="ico-evaluate-good"></span> {{ $i18nUtil.trans("entity.project.projectStatus.GOOD","정상") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.002","이슈가 없는 상황, 정상적으로 진행 중") }}</li>
                </ul>
                <div class="tit">
                  <span class="ico-evaluate-so"></span> {{ $i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.003","이슈/승인/지원 상황 발생에 따른 협의/의사결정 필요") }}</li>
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.004","상위 관리자 주도 下, 이슈 논의 및 의사결정으로 해결") }}</li>
                </ul>
                <div class="tit">
                  <span class="ico-evaluate-delay"></span> {{ $i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.005","상위 관리자 선에서 해결 불가능한 사안, 논의 후 보고 안건 선정") }}</li>
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.006","보고 대상자 의사결정 또는 방향성 논의로 해결") }}</li>
                </ul>
                <div class="tit">
                  <span class="ico-evaluate-exceeded"></span> {{ $i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료") }}
                </div>
                <ul class="list-dot white">
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.007","목표 달성(Task 완료)피벗/재편성, 사업 중단") }}</li>
                  <li>{{ $i18nUtil.trans("message.ProjectFilter.008","상위 관리자/보고 대상자와 논의 후 종료") }}</li>
                </ul>
              </div>
            </div>
          </v-menu>
        </div>
      </div>

      <div class="tit-box">
        <!-- 툴팁 추가 2021-07-09 -->
        <h3 class="ell-singleline" style="display: inline-block; max-width: 85%;"
          @mouseover="mouseEvt(true, $event)"
          @mouseleave="mouseEvt(false, null)"
        >
          <!-- {{ projectNameLengthCheck(projectInfo.project.projectName) }} -->
          {{ projectInfo.project.projectName }}
          <!-- <button
            type="button"
            class="ico-switch_vip"
            :class="{ active: isVip }"
            v-if="isProjectMember"
            @click="setSuperiorMgr"
          >
            경영층
          </button> -->
        </h3>
        <div class="tooltip-b tl small" style="display: inline-block;" :style="{'z-index': tooltip.zIndex, 'display': tooltip.display}">
          {{ projectInfo.project.projectName }}
        </div>
        <button
          type="button"
          class="btn-primary-small black board-add"
          @click="addBoard"
          v-if="folderCount != 0 && isInternalUser"
        >
          {{$i18nUtil.trans("button.paper.pro.add", "과제 보드 추가")}}
        </button>
      </div>

      <div class="storage">
        <div class="calendar_box_grp">
          <div class="calendar_box">
            <datepicker
              format="yyyy.MM.dd"
              v-model="startDate"
              :disabled="grade != 'MANAGER'"
              :placeholder="grade == 'MANAGER' ? $i18nUtil.trans('message.DashBoardHeader.007','시작일 선택') : $i18nUtil.trans('message.DashBoardHeader.008','시작일')"
            ></datepicker>
          </div>
          <span>~</span>
          <div class="calendar_box">
            <datepicker
              format="yyyy.MM.dd"
              v-model="endDate"
              :disabled="grade != 'MANAGER'"
              :placeholder="grade == 'MANAGER' ? $i18nUtil.trans('message.DashBoardHeader.009','종료일 선택') : $i18nUtil.trans('message.DashBoardHeader.010','종료일')"
            ></datepicker>
            <!-- :disabled-dates="{ to: disabledEndDate }"-->
          </div>
          <button
            type="button"
            class="btn-refresh"
            @click="dateReset"
            v-if="grade == 'MANAGER'"
          >
            새로고침
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
/* 보드 팝업 모달 */
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import OtherProjectBoardLink from "@/components/cowork/general/project/modal/OtherProjectBoardLink";
import ProjectSetting from "@/components/cowork/general/project/modal/ProjectSetting";
import InvitationMembers from "@/components/cowork/general/project/modal/InvitationMembers";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import LinkedOkr from "@/components/cowork/general/project/modal/LinkedOkr";
import ProjectComment from "@/components/cowork/general/project/modal/ProjectComment";
import EventBus from "@/js/eventbus/eventBus";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
/* 호출멤버 선택기 */

export default {
  props: [],
  computed: {
    ...mapState("project", ["projectInfo"]), // 현재 정보
    ...mapState("project", ["projectList"]), // 유저가 접근 가능한 모든 리스트
    ...mapState("project", ["projectOkrLinkList"]),
    ...mapState("project", ["projectOkrLinkCount"]),
    ...mapState("project", ["projectMemberList"]), // 현재 멤버 리스트
    ...mapState("project", ["projectMemberCount"]), // 멤버의 수
    ...mapState("project", ["projectCommentCount"]), // 견 수
    ...mapState("project", ["projectInvitationMemberList"]), // 현재 초대 멤버 리스트
    ...mapState("project", ["projectInvitationMemberCount"]), // 초대 멤버의 수
    ...mapState("project", ["selectedFolder"]), // 선택된  정보
  },
  components: {
    Datepicker,
    ProjectComment,
    UserTooltip,
  },
  data() {
    return {
      okrUse: localStorage.getItem("okrUse"),
      tenantId: localStorage.getItem("tenantId"),
      favoriteYn: 0,
      searchMemberList: [],
      searchNoMemberList: [],
      countMyOkrList: 0,
      countOkrList: 0,
      qrtList: [],
      currentQrt: {
        qrtCd: "",
        qrtTopMsg: "",
        qrtTopMsgEn: null,
      },
      isInternalUser: false,
      isProjectMember: false,
      userId: "",
      res: {},
      groupId: null,
      projectId: null,
      invitationCountUser: 0,
      invitationMemberList: null,
      // inoutKbn: "OUT",
      userList: [],
      searchKeyword: "",
      isSearch: false,
      isVip: false,
      status: "",
      startDate: "",
      endDate: "",
      disabledEndDate: "",
      // 로그인한 사용자의 권한
      grade: "",
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      folderCount: 0,
      tooltip: {
        zIndex: 0,
        display: 'none'
      },
      selectFolderCategoryMid:null
    };
  },
  watch: {
    startDate: function () {
      if (this.grade == "MANAGER") {
        this.updateProjectDate("start");
      }
    },
    endDate: function () {
      if (this.grade == "MANAGER") {
        this.updateProjectDate("end");
      }
    },
  },
  created() {
    const self = this;
    $("html").click(function (e) {
      if (!$(e.target).hasClass("member-call-box")) {
        self.isSearch = false;
      }
    });
    const data = [{ test1: "test1", test2: "test2" }];
    var input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("id", "testInput");
    input.setAttribute("value", data);
    document.body.appendChild(input);
    // console.log($.type(document.getElementById("testInput").value));
    let date = new Date();
    date.setDate(date.getDate() - 1);
    this.disabledEndDate = date;

    EventBus.$on("project.comment", (param) => {
      if (param.action === "count" && param.projectId === this.projectId) {
        this.setProjectCommentCount(param.count);
      }
    });
    //임시 okr미사용
    // this.setOkrUse();
  },
  updated() {
    this.updateUserPhoto();
  },
  mounted() {
    // let datepicker = document.querySelectorAll("div.vdp-datepicker div input");
    // for (let i = 0; i < datepicker.length; i++) {
    //   datepicker[i].onfocus = function () {
    //     datepicker[i].blur();
    //   };
    // }
    this.HIDE_CURSOR_DATEPICKER({ self: this });
  },
  methods: {
    ...mapMutations("project", ["setProjectFavoriteList"]), // 즐겨찾기 등록
    ...mapActions("modals", ["showToast"]),
    ...mapActions("coworkUtils", ["HIDE_CURSOR_DATEPICKER"]),
    ...mapActions("modals", ["showModal"]),
    ...mapMutations("project", ["setProjectOkrLinkList"]), // okr연결 리스트
    ...mapMutations("project", ["setProjectOkrLinkCount"]), // okr연결 리스트
    ...mapMutations("project", ["setProjectInvitationMemberList"]),
    ...mapMutations("project", ["setProjectInvitationMemberCount"]),
    ...mapMutations("project", ["setProjectInfo"]), // 현재 정보
    ...mapMutations("project", ["setProjectList"]), // 리스트 setting
    ...mapMutations("project", ["setProjectMemberList"]),
    ...mapMutations("project", ["setProjectMemberCount"]),
    ...mapMutations("project", ["setProjectCommentCount"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO"]),
    ...mapMutations("project", ["setSelectedFolder"]),

    /* 툴팁 */
    mouseEvt(flag, event) {
      if(flag) {
        let val = this.$tooltip.hasOverflownWidth(event.target)
        if(val) {
          this.tooltip.zIndex = 13;
          this.tooltip.display = "inline-block";
        }else{
          this.tooltip.zIndex = 0;
          this.tooltip.display = "none";
        }
      }else{
        this.tooltip.zIndex = 0;
        this.tooltip.display = "none";
      }

    },
    // 초기 데이터 세팅
    setProjectId(res) {
      let obj = this;
      obj.res = res;
      obj.groupId = res.result.project.groupId;
      obj.projectId = res.result.project.projectId;
      obj.getProjectInfo(res);
      // obj.getProjectList();

      /* 의견카운트 */
      let reqData = {
        url: "/api/cogroup/project/getCommentCount",
        method: "post",
        params: {
          projectId: obj.projectId,
          status: status,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((resp) => {
          if (!resp.errorCode) {
            obj.setProjectCommentCount(resp.result);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setCountUser(countUser) {
      let obj = this;
      obj.countUser = countUser;
    },

    getProjectInfo(res) {
      let obj = this;
      obj.favoriteYn = res.result.project.favoriteYn;
      obj.isVip = res.result.project.superiorMgrYn == 1 ? true : false;
      obj.status = res.result.project.status;
      obj.setProjectInfo(res.result);
      obj.groupId = res.result.project.groupId;
      obj.getMemberlist(res.result.project.groupId);
      obj.getInvitationMemberlist(res.result.project.groupId);
      //임시 okr 미사용
      obj.getQrtList();
      obj.isInternalUser = res.result.loginUserIsInternalUser;
      let start = obj.projectInfo.project.startDate;
      let end = obj.projectInfo.project.endDate;
      obj.startDate =
        start == ""
          ? ""
          : new Date(
              start.substring(0, 4) +
                "-" +
                start.substring(4, 6) +
                "-" +
                start.substring(6)
            );
      obj.endDate =
        end == ""
          ? ""
          : new Date(
              end.substring(0, 4) +
                "-" +
                end.substring(4, 6) +
                "-" +
                end.substring(6)
            );
      obj.userId = res.result.loginUserId;

      this.$nextTick(function(){
        if(this.$route.query.commentYn != null){
          this.$refs.viewCommentBtn.$el.click();
        }
      })
    },
    getProjectList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/project/getProjectList",
        method: "post",
        req: {
          // projectId: projectId
        },
      };
      this.ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          obj.setProjectList(res.result);
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    /* 멤버  */
    getMemberlist(groupId) {
      let obj = this;
      let reqData = {};
      reqData.req = {
        groupId: groupId,
      };
      reqData.url = "/api/cogroup/cogroupUser/getCogroupUserList";
      reqData.method = "post";
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          // console.log(res);
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.setProjectMemberList(res.result.data);
            obj.setProjectMemberCount(res.result.countuser);
            obj.grade = res.result.grade;
            for (let i = 0; i < obj.projectMemberList.length; i++) {
              if (obj.projectMemberList[i].userId == obj.userId) {
                obj.isProjectMember = true;
              }
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 초대 멤버  */
    getInvitationMemberlist(groupId) {
      let obj = this;
      let reqData = {};
      reqData.req = {
        groupId: groupId,
      };
      reqData.url = "/api/cogroup/cogroupUserManage/getCogroupUserManageList";
      reqData.method = "post";
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          if (!res.errorCode) {
            //console.log("getCogroupUserManageList", res.result);
            obj.setProjectInvitationMemberList(res.result.data);
            obj.setProjectInvitationMemberCount(res.result.count);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 보드 만들기 모달 호출 */
    addBoard() {
      
      // 전체 탭 사용계열사에서 다른 업무이동시 이동전 세팅된 category값 사용 제거.
      let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
      if(stateArr.length == 0){
      }else{
          let localStorageAllListYn  = localStorage.getItem("boardAllListUse");
          this.selectFolderCategoryMid = null;
          let lastState = stateArr[stateArr.length-1];
          if(localStorageAllListYn === "true"){
            if(!(lastState.currentTab == 0 && lastState.currentTab2 == 1 && lastState.currentTab3 == 0)){
              this.setSelectedFolder(null); 
            }else{
              this.selectFolderCategoryMid = lastState.categoryMid;
            }
          }else{
            if(!(lastState.currentTab == 0 && lastState.currentTab2 == 0 && lastState.currentTab3 == 0)){
              this.setSelectedFolder(null); 
            }else{
              this.selectFolderCategoryMid = lastState.categoryMid;
            }
          }
      }

      let obj = this;
      let reqData = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/getGeneratedPaperId";
      reqData.method = "post";
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          let errorCode = res.errorCode;
          let addPaperId = res.result;
          const modalInfo = {
            title: obj.$i18nUtil.trans("title.RegistBoardModal.000", "업무보드 추가"),
            name: "registBoard",
            method: "post",
            width: "800px",
            // height: "493px",
            obj: obj.$modal,
            paperId: addPaperId,
            // categoryMid: obj.$refs.assignDashboard.selectCategory.category.categoryMid,
            // groupId: obj.$refs.assignDashboard.selectCategory.category.groupId,
            // categoryMid: null,
            categoryMid:
              obj.selectedFolder == null
                ? obj.selectFolderCategoryMid == null ? null : obj.selectFolderCategoryMid 
                :obj.selectedFolder.categoryMid,
            groupId: obj.groupId,
            //projectId : obj.projectId,
            projectId: this.projectId,
            projectName: this.projectInfo.project.projectName,
            docGrade:
              String(this.projectInfo.cogroup.publicYn) == "1"
                ? "NORMAL"
                : "RESTRICT",
            paperTitle: "",
            contentPath: "",
            component: RegistBoardModal,
          };
          obj.showModal(modalInfo);
        })

        .catch(function (err) {
          console.log(err);
        });
    },

    setSuperiorMgr() {
      if (!this.isProjectMember) {
        this.toastInfo.message = this.$i18nUtil.trans("TB053", "권한이 없습니다. 과제 운영자에게 문의하세요.");
        this.showToast(this.toastInfo);
        return;
      }
      let obj = this;
      let reqData = {
        url: "/api/cogroup/project/updateProjectSuperiorMgr",
        method: "post",
        req: {
          projectId: obj.projectId,
          groupId: obj.groupId,
          superiorMgrYn: obj.isVip == true ? "0" : "1",
        },
      };
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode) {
          } else {
            // obj.getProjectInfo(obj.projectId);
            obj.isVip = obj.isVip == true ? false : true;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    addMember(event) {
      let modalInfo = {};
      // if (this.grade == "MANAGER") {
        modalInfo = {
          title: this.$i18nUtil.trans("title.MultiOrg.001", "조직도"),
          method: "post",
          width: "1050px",
          height: "860px",
          obj: this.$modal,
          //orgType: "SINGLE_USER",
          //orgType: "MULTI_USER",
          orgType: "MULTI_ORG",
          //orgType: "SINGLE_DEPT",
          //orgType: "MULTI_DEPT",
          //component: Organization,
          component: MultiOrg,
          url: "/api/org/getDeptList",
        };
      // } else {
        // modalInfo = {
        //   title: "알림",
        //   width: "400px",
        //   // height: "166px",
        //   obj: this.$modal,
        //   contents: "운영자만 접근권한이 있습니다.",
        //   button: "확인",
        //   component: Dialog,
      //   };
      // }

      this.showModal(modalInfo);
    },
    /* 외부협력사 멤버 초대 */
    invitationMember(event) {
      const obj = this;
      if (this.isProjectMember) {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.InvitationMembers.000", "멤버 초대"),
          width: "800px",
          // height: "582px",
          obj: this.$modal,
          listType: this.listType,
          groupId: this.groupId,
          component: InvitationMembers,
        };
        this.showModal(modalInfo);
      } else {
        this.toastInfo.message = this.$i18nUtil.trans("TB053", "권한이 없습니다. 과제 운영자에게 문의하세요.");
        this.showToast(this.toastInfo);
        return;
      }
    },
    showDialog(grade, userId, userName, userKbn, dialogType) {
      let deleteUserList = [];
      const jsonData = { userId: userId, userKbn: userKbn, userGrade: grade };
      deleteUserList.push(jsonData);
      if (dialogType == "SELF_REJECT") {
        if (grade == "MANAGER") {
          let managerYn = 0;
          for (let i = 0; i < this.projectMemberList.length; i++) {
            if (this.projectMemberList[i].userGrade == "MANAGER") {
              managerYn++;
            }
          }
          if (managerYn == 1) {
            const modalInfo = {
              title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
              width: "400px",
              // height: "166px",
              obj: this.$modal,
              contents: this.$i18nUtil.trans("AB064", "운영자는 1명 이상 등록되어야 합니다."),
              button: this.$i18nUtil.trans("button.dialog.confirm", "확인"),
              component: Dialog,
            };
            this.showModal(modalInfo);
            return;
          }
        }
        const dialogContents = this.$i18nUtil.trans("AB072", "과제 탈퇴 시 다시 접근할 수 없으며, 연결된 모든  접근 권한도 사라지게 됩니다.\n단, 비공개 보드는 나의 공간>공유받은 보드에서 권한이 유지됩니다. 탈퇴하시겠습니까?");
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
          width: "400px",
          // height: "166px",
          obj: this.$modal,
          deleteUserList: deleteUserList,
          contents: dialogContents,
          button: this.$i18nUtil.trans("button.resign", "탈퇴"),
          subButton: this.$i18nUtil.trans("button.cancel", "취소"),
          dialogType: dialogType,
          component: Dialog,
        };
        this.showModal(modalInfo);
      } else {
        const dialogContents = this.$i18nUtil.trans("AB020", "멤버 제외 시 다시 접근할 수 없으며, 연결된 모든 접근 권한도 사라지게 됩니다. 제외하시겠습니까?", {
          userName: userName,
          targetName: this.projectInfo.project.projectName,
        });
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.except.member", "멤버 제외"),
          width: "400px",
          // height: "166px",
          obj: this.$modal,
          deleteUserList: deleteUserList,
          contents: dialogContents,
          button: this.$i18nUtil.trans("button.except", "제외"),
          subButton: this.$i18nUtil.trans("button.cancel", "취소"),
          dialogType: dialogType,
          component: Dialog,
        };
        this.showModal(modalInfo);
      }
    },
    // 타 보드 링크
    otherProjectBoardLink() {
      const modalInfo = {
        title: this.$i18nUtil.trans("entity.project","과제"),
        width: "800px",
        // height: "479px",
        obj: this.$modal,
        component: OtherProjectBoardLink,
        groupId: this.groupId,
        projectId: this.projectId,
        // inoutKbn: this.inoutKbn,
      };
      this.showModal(modalInfo);
    },
    // 설정
    projectSetting(type) {
      // console.log(this.grade);
      if (this.grade != "MANAGER") {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
          width: "400px",
          // height: "166px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("message.dialog.permission.deny","운영자만 접근권한이 있습니다."),
          button: this.$i18nUtil.trans("button.dialog.confirm", "확인"),
          component: Dialog,
        };
        this.showModal(modalInfo);
        return;
      }
      const modalInfo = {
        title: this.$i18nUtil.trans("title.ProjectSetting.001", "과제 설정"),
        width: "1220px",
        height: "650px",
        obj: this.$modal,
        listType: this.listType,
        component: ProjectSetting,
        groupId: this.groupId,
        projectId: this.projectId,
        type: type,
        // inoutKbn: this.inoutKbn,
      };
      this.showModal(modalInfo);
    },
    searchByKeyword(event) {
      this.searchKeyword = event.target.value;
      if (this.searchKeyword.length > 1) {
        this.isSearch = true;
        let obj = this;
        let reqData = {};
        reqData.req = {
          searchKeyword: this.searchKeyword,
        };
        reqData.url = "/api/auth/org/searchByUserName";
        reqData.method = "post";

        obj
          .COWORK_REST_ACTION(reqData)
          .then(function (data) {
            if (!data.errorCode) {
              obj.userList = data.result;
              obj.searchMemberList = [];
              obj.searchNoMemberList = [];
              obj.userList.forEach((item) => {
                let memberCheck = false;

                obj.projectMemberList.forEach((value) => {
                  if (value.userId == item.userId) {
                    memberCheck = true;
                  }
                });
                if (memberCheck) {
                  obj.searchMemberList.push(item);
                } else {
                  obj.searchNoMemberList.push(item);
                }
              });
            }
            setTimeout(obj.updateUserPhoto, 500);
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        this.isSearch = false;
        this.userList = [];
      }
    },
    joinCheck(userId) {
      const obj = this;
      for (let i = 0; i < obj.projectMemberList.length; i++) {
        if (userId == obj.projectMemberList[i].userId) {
          return true;
        } else {
          continue;
        }
      }
      return false;
    },

    invitationApprove(userMngMid, email) {
      // 가입 승인
      const obj = this;
      const reqData = {
        url: "/api/cogroup/cogroupUser/registCogroupUser",
        method: "post",
        obj: obj,
        req: {
          groupId: obj.groupId,
          addCogroupUserList: [
            {
              userId: email,
              userGrade: "MEMBER",
              userKbn: "01",
            },
          ],
          userMngMid: [userMngMid],
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          if (!res.errorCode) {
            if(res.result.checkPolicy && res.result.checkPolicy.length >0 ){
              let checkPolicy = "";
              res.result.checkPolicy.forEach((res)=>{
                checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
              })
              obj.showAlertDialog(obj.$i18nUtil.trans("AB112",{ checkPolicy: checkPolicy}));
              return;
            }
            obj.setProjectMemberList(res.result.data);
            obj.setProjectMemberCount(res.result.countuser);
            obj.getInvitationMemberlist(obj.groupId);
            obj.toastInfo.message = obj.$i18nUtil.trans("TB064", "과제 멤버로 추가되었습니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("[가입승인 오류]");
        });
    },
    reInvitationMember(invitationMember) {
      //다시 초대
      const obj = this;
      const reqData = {
        url: "/api/cogroup/cogroupUser/reInvitation",
        method: "post",
        obj: obj,
        req: {
          invitationMember: invitationMember,
          groupId: obj.groupId,
        },
      };

      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          if (!res.errorCode) {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB063", "{countInviteMember}명에게 초대 메일이 발송되었습니다.", { countInviteMember: 1 });
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("[다시초대 오류]");
        });
    },
    selectProjectUser(data, index) {
      if (index < 0) {
        return;
      }
      if (this.joinCheck(data.userId)) {
        this.toastInfo.message = this.$i18nUtil.trans("message.Dashboard.009","이미 등록된 멤버입니다.");
        this.showToast(this.toastInfo);
        return;
      }
      let modalInfo = {};
      // if (this.grade == "MANAGER") {
        modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.add.member", "멤버 추가"),
          width: "400px",
          // height: "166px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("message.dialog.add.member","멤버로 추가하시겠습니까?"),
          button: this.$i18nUtil.trans("button.dialog.add", "추가"),
          subButton: this.$i18nUtil.trans("button.dialog.cancel", "취소"),
          data: data,
          dialogType: "ADD_MEMBER",
          component: Dialog,
        };
      // } else {
      //   modalInfo = {
      //     title: "멤버 추가",
      //     width: "400px",
      //     // height: "166px",
      //     obj: this.$modal,
      //     contents: "운영자만 접근권한이 있습니다.",
      //     button: "확인",
      //     component: Dialog,
      //   };
      // }

      this.showModal(modalInfo);
    },
    projectNameLengthCheck(data) {
      let len = 60;
      return this.cutByteLength(data, len);
    },
    /* byte 체크 */
    displayBytes(byteLength, addCategoryName, _event) {
      let obj = this;
      addCategoryName = _event.target.value;
      obj.addCategoryName = addCategoryName;
      let checkBytes = obj.getByteLength(obj.addCategoryName);
      obj.checkBytes = checkBytes;
      obj.error = false;
      if (checkBytes > byteLength) {
        obj.error = true;
      }
      if (checkBytes > 0) {
        obj.errorFolderName = false;
      }
    },
    getByteLength(str) {
      if (str == null || str.length == 0) {
        return 0;
      }
      var size = 0;
      for (var i = 0; i < str.length; i++) {
        size += this.charByteSize(str.charAt(i));
      }
      return size;
    },
    cutByteLength(s, len) {
      if (s == null || s.length == 0) {
        return 0;
      }
      var size = 0;
      var rIndex = s.length;
      for (var i = 0; i < s.length; i++) {
        size += this.charByteSize(s.charAt(i));
        if (size == len) {
          rIndex = i + 1;
          break;
        } else if (size > len) {
          rIndex = i;
          break;
        }
      }
      return s.substring(0, rIndex);
    },
    charByteSize(ch) {
      if (ch == null || ch.length == 0) {
        return 0;
      }
      var charCode = ch.charCodeAt(0);

      if (charCode <= 0x00007f) {
        return 1;
      } else if (charCode <= 0x0007ff) {
        return 2;
      } else if (charCode <= 0x00ffff) {
        return 2;
      } else {
        return 2;
      }
    },
    getProjectOkrLink(qrtCd) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getProjectOkrList",
        method: "post",
        req: {
          projectId: this.projectId,
          qrtCd: this.currentQrt.qrtCd,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then(function (res) {
          if (!res.errorCode) {
            obj.setProjectOkrLinkList(res.result.data);
            obj.setProjectOkrLinkCount(res.result.count);
            obj.projectOkrLinkList.forEach((value) => {
              if (value.regUserId == obj.userId) {
                obj.countMyOkrList = obj.countMyOkrList + 1;
              } else {
                obj.countOkrList = obj.countOkrList + 1;
              }
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    ChangeOkrType(type) {
      let resultType = "";
      if (type == "MO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.MO","개인 O");
      } else if (type == "UO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.UO","유닛 O");
      } else if (type == "TO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.TO","팀 O");
      } else if (type == "HO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.HO","본부 O");
      } else if (type == "CO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.CO","회사 O");
      } else if (type == "MK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.MK","개인 KR");
      } else if (type == "UK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.UK","유닛 KR");
      } else if (type == "TK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.TK","팀 KR");
      } else if (type == "HK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.HK","본부 KR");
      } else {
        resultType = this.$i18nUtil.trans("message.project.OKR.else","회사 KR");
      }
      return resultType;
    },
    LinkedOkrPopup() {
      // if (!this.isProjectMember) {
      //   this.toastInfo.message = this.$i18nUtil.trans("TB053");
      //   this.showToast(this.toastInfo);
      //   return;
      // }
      const modalInfo = {
        title: this.$i18nUtil.trans("title.LinkedOkr.001", "OKR연결 추가"),
        width: "800px",
        // height: "743px",
        obj: this.$modal,
        projectId: this.projectInfo.project.projectId,
        projectName: this.projectInfo.project.projectName,
        publicYn: this.projectInfo.cogroup.publicYn.toString(),
        startDate: this.startDate,
        endDate: this.endDate,
        type: "OkrLink",
        component: LinkedOkr,
      };
      this.showModal(modalInfo);
    },
    OkrDisconnection(id) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/deleteProjectOkrLink",
        method: "post",
        req: {
          projectId: this.projectId,
          projectOkrLinkId: id,
          qrtCd: this.currentQrt.qrtCd,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then(function (res) {
          if (!res.errorCode) {
            obj.setProjectOkrLinkList(res.result.data);
            obj.setProjectOkrLinkCount(res.result.count);
            obj.toastInfo.message = obj.$i18nUtil.trans("TB081", "연결이 해제되었습니다.");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    registProjectFavorites(event) {
      let obj = this;
      const projectId = this.projectId;
      let reqData = {
        method: "post",
        params: { projectId: projectId },
      };
      if (this.favoriteYn == 0) {
        /* 즐겨찾기 등록 */
        reqData.url = "/api/cogroup/project/registProjectFavorites";
        this.toastInfo.message = this.$i18nUtil.trans("TB041", "즐겨찾기가 설정되었습니다.");
      } else {
        /* 즐겨찾기 해제 */
        reqData.url = "/api/cogroup/project/deleteProjectFavorites";
        this.toastInfo.message = this.$i18nUtil.trans("TB042", "즐겨찾기가 해제되었습니다.");
      }
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (obj.favoriteYn == 0) {
              obj.favoriteYn = 1;
            } else {
              obj.favoriteYn = 0;
            }
            obj.setProjectFavoriteList(res.result);
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    projectAllComment() {
      let param = {
        userId: this.userId,
        projectId: this.projectId,
      };
      EventBus.$emit("projectAllCommentRefresh", param);
    },
    /* 회원검색시 이미 멤버일 경우 추가버튼 x */
    memberCheck(userId) {
      let isMember = true;
      this.projectInvitationMemberList.forEach((value) => {
        if (value.userId == userId) {
          isMember = false;
        }
      });
      return isMember;
    },
    updateProjectDate(type) {
      if (
        this.startDate > this.endDate ||
        this.startDate == "" ||
        this.endDate == ""
      ) {
        if (type == "start") {
          this.endDate = this.startDate;
        } else {
          this.startDate = this.endDate;
        }
        return;
      } else {
        let obj = this;
        let reqData = {
          url: "/api/cogroup/project/updateProjectDate",
          method: "post",
          req: {
            groupId: this.groupId,
            projectId: this.projectId,
            startDate:
              this.startDate == "" ? "" : this.changeDate(this.startDate),
            endDate: this.endDate == "" ? "" : this.changeDate(this.endDate),
          },
        };

        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (data.errorCode) {
              console.log(data.errorCode);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    updateProjectStatus(status) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/project/updateProjectStatus",
        method: "post",
        req: {
          groupId: this.groupId,
          projectId: this.projectId,
          status: status,
        },
      };

      obj
        .COWORK_REST_ACTION(reqData)
        .then((data) => {
          if (data.errorCode) {
            console.log(data.errorCode);
          } else {
            const statusNameOld =
              obj.status == "GOOD"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.GOOD","정상")
                : obj.status == "SO"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생")
                : obj.status == "DELAY"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요")
                : obj.status == "EXCEEDED"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료")
                : "";
            obj.status = status;
            const statusNameNew =
              obj.status == "GOOD"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.GOOD","정상")
                : obj.status == "SO"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.SO","이슈 발생")
                : obj.status == "DELAY"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.DELAY","보고 필요")
                : obj.status == "EXCEEDED"
                ? obj.$i18nUtil.trans("entity.project.projectStatus.EXCEEDED.002","종료")
                : "";

            obj.toastInfo.message = obj.$i18nUtil.trans("TB001", {
              statusNameOld: statusNameOld,
              statusNameNew: statusNameNew,
            });
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const days = date.getDate();
      const currentTime =
        year.toString() +
        (month > 9 ? month : "0" + month).toString() +
        (days > 9 ? days : "0" + days).toString();
      return currentTime;
    },
    folderLength(data) {
      this.folderCount = data;
    },
    // okr 분기목록가져오기
    getQrtList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getProjectQrtList",
        method: "post",
        req: {
          projectId: obj.projectId,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then((data) => {
          // console.log(data);
          if (!data.errCode) {
            obj.qrtList = data.result;
            let currQrtCheck = false;
            for (let i = 0; i < obj.qrtList.length; i++) {
              if (obj.qrtList[i].CURR_QRT_YN == 1) {
                currQrtCheck = true;
                obj.currentQrt.qrtCd = obj.qrtList[i].QRT_CD;
                obj.currentQrt.qrtTopMsg = obj.qrtList[i].QRT_TOP_MSG;
                obj.currentQrt.qrtTopMsgEn = obj.qrtList[i].QRT_TOP_MSG_EN;
                obj.getProjectOkrLink(obj.qrtList[i].QRT_CD);
                break;
              }
            }
            if (!currQrtCheck && obj.qrtList.length > 0) {
              obj.currentQrt.qrtCd = obj.qrtList[0].QRT_CD;
              obj.currentQrt.qrtTopMsg = obj.qrtList[0].QRT_TOP_MSG;
              obj.currentQrt.qrtTopMsgEn = obj.qrtList[0].QRT_TOP_MSG_EN;
              obj.getProjectOkrLink(obj.qrtList[0].QRT_CD);
            }
            if (obj.qrtList.length == 0) {
              obj.setProjectOkrLinkList([]);
              obj.setProjectOkrLinkCount(0);
            }
          }
        })
        .catch((err) => {
          alert("getQrtList fail");
        });
    },
    qrtChange(qrtCd, event) {
      this.currentQrt.qrtCd = qrtCd;
      this.currentQrt.qrtTopMsg = event.target.innerText;
      this.getProjectOkrLink(qrtCd);
    },
    // 멤버검색 리셋
    searchReset() {
      this.isSearch = false;
      $("#searchInput").val("");
    },
    dateReset() {
      this.startDate = "";
      this.endDate = "";
    },
    clickMemberSearchBtn() {
      if (this.searchKeyword.length > 0) {
        this.isSearch = false;
        this.searchKeyword = 0;
      }
    },
    updateUserPhoto() {
      let list = this.$el.querySelectorAll("div.user-photo[data-user-id]");
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let userId = elem.getAttribute("data-user-id");
          let img = elem.querySelector("img");
          this.HW_GET_USER_PHOTO({ img, userId });
        }
      }
    },
  },
};
</script>

<style scoped>
  .ico-master-en {
    width: 80px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/DashBoardHeader.vue